import { render, staticRenderFns } from "./addGoodsDrawer.vue?vue&type=template&id=705c6ab0&scoped=true"
import script from "./addGoodsDrawer.vue?vue&type=script&lang=js"
export * from "./addGoodsDrawer.vue?vue&type=script&lang=js"
import style0 from "./addGoodsDrawer.vue?vue&type=style&index=0&id=705c6ab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c6ab0",
  null
  
)

export default component.exports